import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetNumberPlatEventDetail } from "../../../api/api";
import TimeTakenChart from "../../../Components/Graphs/TimeTakenChart";
import CustomTable from "../../../ui/custom-table";
import { TbClock } from "react-icons/tb";
import { FaRegUser } from "react-icons/fa";
import {
  MdOutlineCalendarMonth,
  MdOutlineLocationOn,
  MdWifiTethering,
} from "react-icons/md";
import { IoCameraOutline } from "react-icons/io5";
import PeakHoursChart from "../../../Components/Graphs/HourlyVehicleChart";

function NumberPlatDetail() {
  const navigate = useNavigate();
  const [eventData, setEventData] = useState([]);
  //console.log("eventData", eventData);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const [eventrecord, setEventRecord] = useState([]);
  //console.log("eventrecord", eventrecord);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  //   const start_date = today.toISOString().split("T")[0]; // e.g., '2025-07-24'
  //   const end_date = start_date;
  const formattedDate = today.toLocaleDateString("en-GB", options);
  const [activeFilter, setActiveFilter] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [showCustomFilter, setShowCustomFilter] = useState(false);

  const fetchEventData = async () => {
    setLoading(true);
    try {
      const data = await GetNumberPlatEventDetail(startDate, endDate);
      //console.log("data", data);
      if (data?.data?.status === true) {
        setEventData(data?.data?.stats);
        setEventRecord(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEventData();
    updateDateRange("daily");
  }, []);

  const updateDateRange = (filter) => {
    const today = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = today;
        break;
      case "weekly":
        start = new Date(today);
        start.setDate(today.getDate() - 7);
        end = today;
        break;
      case "monthly":
        start = new Date(today);
        start.setMonth(today.getMonth() - 1);
        end = today;
        break;
      default:
        start = end = today;
    }

    const format = (date) => date.toISOString().split("T")[0];
    setStartDate(format(start));
    setEndDate(format(end));
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "image_path",
        header: "Student Image",
        Cell: ({ row }) => {
          const imagePath = row.original.image_path;
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com/numberplate/${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },

      { accessorKey: "number_detected", header: "Number" },
    ],
    []
  );

  useEffect(() => {
    if (startDate && endDate) {
      fetchEventData();
    }
  }, [startDate, endDate]);

  return (
    <div>
      <div>
        <div className="p-5 bg-white">
          <h3 className="mb-4">Vehicle Plate Tracking</h3>
          <div className="customerDwellTime">
            <div className="itemsBox">
              <span>
                <IoCameraOutline size={26} />
              </span>
              <div className="">
                <h5>Camera</h5>
                <h3>Cash Counter</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineLocationOn size={26} />
              </span>
              <div className="">
                <h5>Location</h5>
                <h3>Cashier Area</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineCalendarMonth size={26} />
              </span>
              <div className="">
                <h5>Tracking</h5>
                <h3>{formattedDate}</h3>
              </div>
            </div>

            <div className="itemsBox" style={{ marginLeft: "auto" }}>
              <button
                className="eventModeBtn"
                onClick={() => navigate("/numberplat")}
                style={{
                  backgroundColor: "red",
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <MdWifiTethering size={18} />
                Live
              </button>
            </div>
          </div>
        </div>
        <div className="p-5 border-top">
          <div className="d-flex">
            <h4 className="">Vehicle Analyses</h4>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="customerAnalysesGrid">
                <div className="itemsBox">
                  <span>
                    <FaRegUser size={30} />
                  </span>
                  <div className="">
                    <h5>Total Vehicle Detect</h5>
                    <div className="customer">
                      {eventData?.total_vehicles_detected}
                      <p>Students</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Unique Number Plat</h5>
                    <div className="customer">
                      {eventData?.unique_plate_numbers}
                      <p>Students</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Busyest Hour</h5>
                    <div className="customer">{eventData?.busiest_hour}</div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Total Records</h5>
                    <div className="customer">
                      {eventrecord?.length}
                      <p>Records</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="filter-toggle-wrapper d-flex justify-content-end mb-3 flex-wrap">
                <div className="filter-toggle-group">
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "daily" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("daily");
                      updateDateRange("daily");
                    }}
                  >
                    Daily
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "weekly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("weekly");
                      updateDateRange("weekly");
                    }}
                  >
                    Weekly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "monthly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("monthly");
                      updateDateRange("monthly");
                    }}
                  >
                    Monthly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "custom" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("custom");
                      updateDateRange("custom");
                      setShowCustomFilter(true);
                    }}
                  >
                    Custom
                  </button>
                </div>
                {activeFilter === "custom" && showCustomFilter && (
                  <div className="d-flex gap-3 align-items-center mb-3 flex-wrap custom-date-wrapper p-3 bg-light rounded">
                    <div>
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customStart}
                        onChange={(e) => setCustomStart(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customEnd}
                        onChange={(e) => setCustomEnd(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        className="btn btn-primary mt-4"
                        onClick={() => {
                          setStartDate(customStart);
                          setEndDate(customEnd);
                          setShowCustomFilter(false);
                        }}
                        disabled={!customStart || !customEnd}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="graphBox p-4 bg-white shadow-sm rounded">
                <PeakHoursChart
                  data={eventData?.hourly_vehicle_distribution || []}
                />{" "}
              </div>
            </div>
          </div>

          <div className="mt-5 cstTableCls">
            <CustomTable
              columns={columns}
              data={eventrecord}
              loading={loading}
              showsearch={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NumberPlatDetail;
